export default "__VITE_ASSET__CIlEceEP__"